"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.CustomStyled = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // eslint-disable-next-line import/prefer-default-export


var CustomStyled = _styledComponents.default.div.attrs(function (_ref) {
  var iconPosition = _ref.iconPosition;
  return {
    style: {
      left: "".concat(iconPosition.left, "%"),
      top: "".concat(iconPosition.top, "%")
    }
  };
}).withConfig({
  displayName: "customstyles__CustomStyled",
  componentId: "eamqlu-0"
})(["position:absolute;font-size:3em;transition:all 200ms ease;-webkit-backface-visibility:hidden;transform:", " ", ";", " ", " &.show{visibility:visible;transition:", ";}&.hide{opacity:0 !important;visibility:hidden;transition:", ";}"], _hotspotGlobal.translateXY, function (props) {
  return props.isChrome && "\n    translateZ(0) scale(1.0, 1.0)\n  ";
}, function (_ref2) {
  var config = _ref2.config;
  return config;
}, function (props) {
  return props.hoverEffect && "\n    visibility: hidden;\n  ";
}, function (props) {
  return props.transition && props.transition.showTransition;
}, function (props) {
  return props.transition && props.transition.hideTransition;
});

exports.CustomStyled = CustomStyled;

var hoverState = function hoverState(hoverStyle) {
  return "\n  ".concat(CustomStyled, " {\n    ").concat(hoverStyle, "\n  }\n");
};

var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "customstyles__ClickableAreaStyled",
  componentId: "eamqlu-1"
})(["", ""], function (_ref3) {
  var disableHover = _ref3.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", "}", ""], _hotspot.focusVisible, function (_ref4) {
    var hoverStyle = _ref4.hoverStyle;
    return hoverState(hoverStyle);
  }, function (_ref5) {
    var hoverStyle = _ref5.hoverStyle,
        previewHoverState = _ref5.previewHoverState;
    return previewHoverState && hoverState(hoverStyle);
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;